/** @jsxImportSource @emotion/react */
import { H1, Input, Label } from "atoms";
import React, { useState } from "react";
import { Head } from "features/misc";
import { useAdminUserSearch } from "../api/useUserSearch";
import { UserSearchResults } from "./UserSearchResults";

const css = {
  form: {
    marginLeft: "auto",
    marginRight: "auto",
  },
  label: {
    margin: "1rem 0",
  },
  buttonWrapper: {
    display: "flex",
    flexDirection: "row" as const,
    alignItems: "baseline",
  },
  results: {
    marginTop: "1rem",
  },
  table: {
    th: {
      textAlign: "left" as const,
      paddingRight: "8px",
    },
  },
  hugs: {
    display: "flex",
    img: {
      maxWidth: "100px",
      margin: "4px",
    },
  },
  input: {
    borderColor: "black",
    maxWidth: "600px",
  },
  firstColumn: {
    width: "250px",
    textAlign: "right",
  } as const,
  searchResult: {
    marginTop: "40px",
    marginBottom: "60px",
  },
};

function UserSearch() {
  const [query, setQuery] = useState<string | undefined>();
  const [querySubmitted, setQuerySubmitted] = useState<string | undefined>();
  const { data } = useAdminUserSearch(querySubmitted);

  const onSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    if (query) {
      setQuerySubmitted(query);
    }
  };

  return (
    <main>
      <Head title="Users | Admin" />

      <H1>User Search</H1>
      <form css={css.form} onSubmit={onSubmit}>
        <Label css={css.label}>
          Search by Wallet or Discord Username
          <Input
            css={css.input}
            name="query"
            onChange={(e) => setQuery(e.target.value)}
          />
        </Label>
      </form>
      {data?.data && <UserSearchResults results={data.data} />}
    </main>
  );
}

export { UserSearch };
